'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'underscore';
import { jsx as _jsx } from "react/jsx-runtime";
const HOC = Component => {
  class WithUniqueMenuId extends PureComponent {
    constructor(props) {
      super(props);
      this.menuId = uniqueId('MenuId');
      this.getMenuId = this.getMenuId.bind(this);
    }
    getMenuId() {
      return this.props.menuId ? this.props.menuId : this.menuId;
    }
    render() {
      return /*#__PURE__*/_jsx(Component, Object.assign({}, this.props, {
        menuId: this.getMenuId()
      }));
    }
  }
  WithUniqueMenuId.propTypes = {
    menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };
  return WithUniqueMenuId;
};
export default function withUniqueMenuId() {
  return HOC;
}